import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('ct_theme');
      if (saved) return saved === 'dark';
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return false;
  });
  const [autoSchedule, setAutoSchedule] = useState(() => localStorage.getItem('ct_theme_auto') === 'true');

  useEffect(() => {
    if (!autoSchedule) return;
    const checkTime = () => {
      const hour = new Date().getHours();
      const shouldBeDark = hour >= 20 || hour < 7;
      setDark(shouldBeDark);
    };
    checkTime();
    const interval = setInterval(checkTime, 60000);
    return () => clearInterval(interval);
  }, [autoSchedule]);

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('ct_theme', dark ? 'dark' : 'light');
  }, [dark]);

  const toggleAutoSchedule = () => {
    const next = !autoSchedule;
    setAutoSchedule(next);
    localStorage.setItem('ct_theme_auto', next ? 'true' : 'false');
  };

  return (
    <ThemeContext.Provider value={{ dark, setDark, toggle: () => { setAutoSchedule(false); localStorage.setItem('ct_theme_auto', 'false'); setDark(d => !d); }, autoSchedule, toggleAutoSchedule }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
